import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import PartnerTemplate from '../../components/partnermng/PartnerTemplate';

import {
  unloadPartner,
  viewPartner,
} from '../../modules/partnerModule/partner';
import PartnerFormContainer from './PartnerFormContainer';
import ParFileListContainer from './files/ParFileListContainer';
import ParEmpListContainer from './employees/ParEmpListContainer';
import ParEmpFormContainer from './employees/ParEmpFormContainer';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import ParMultiFileFormContainer from './files/ParMultiFileFormContainer';
import ParProductPriceListContainer from './productprice/ParProductPriceListContainer';
import ParProductPriceFormContainer from './productprice/ParProductPriceFormContainer';
import PartnerGuideInfo from '../../components/partnermng/PartnerGuideInfo';

const PartnerEditContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { partner, error, loading } = useSelector(
    ({ partnerModule, loading }) => ({
      partner: partnerModule.partner.partner,
      error: partnerModule.partner.error,
      loading: loading['partner/VIEW_PARTNER'],
    }),
  );

  useEffect(() => {
    dispatch(viewPartner(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadPartner());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (partner) {
      let title = {
        name: '[' + partner.partnerTyp + '] ' + partner.partnerNm,
        no: partner.partnerUuid,
      };
      setTitleData(title);
    }
  }, [partner]);

  const handleGoBack = () => {
    navigate(`/partnermng/${id}`);
  };

  const handleDelete = () => {
    console.log(partner);
  };

  return (
    <PartnerTemplate partner={partner} loading={loading} error={error}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="마스터/거래처 관리/수정"
        menuLink="/partnermng"
        icon="partner"
        titleData={titleData}
      />
      <Box sx={{ my: 1 }}>
        <PartnerGuideInfo />
      </Box>
      <DetailTemplate title="기본정보">
        <PartnerFormContainer type="edit" />
      </DetailTemplate>
      <DetailTemplate title="거래처 파일 관리">
        <ParFileListContainer />
        <ParMultiFileFormContainer />
      </DetailTemplate>
      <DetailTemplate title="거래처 담당자 관리">
        <ParEmpListContainer />
        <ParEmpFormContainer />
      </DetailTemplate>
    </PartnerTemplate>
  );
};

export default PartnerEditContainer;
